export default "__VITE_PUBLIC_ASSET__386602ce__"